<template>
  <router-view/>
</template>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* transform: translate3d(0, 0, 0); */
}
html, body{
  width: 100%;
  height: 100%;
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;

  background: #ccc;
  /* 可自定义灰色程度 */
  /* filter: grayscale(0.95);  */
}
html{
  font-size: 5.2vw;
  overflow: hidden;
  // overflow-y: scroll;
}
body{
  font-size: 16px;
}

</style>
